import { useContext } from "react"
import { ThemeContext } from "../context/theme/ThemeState"


export const useTheme= () =>{
    const context = useContext(ThemeContext)     // crea un contexto el cual contiene todo lo que se ha creado en UserState
    return { ...context}

}